import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@collaborate-health/uikit'
import { CertificatesDisplayType } from '@tabeeb/modules/certificates/constants'
import React from 'react'
import CertificatesGrid from '../CertificatesGrid'

export interface ContractCertificatesDialogProps {
  open: boolean
  contractVersion: {
    Id: number
  }
  onClose: () => void
}

const ContractCertificatesDialog: React.FC<ContractCertificatesDialogProps> = ({ open, contractVersion, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='lg'>
      <DialogTitle>Contract certificates</DialogTitle>

      <DialogContent>
        <CertificatesGrid simpleView displayType={CertificatesDisplayType.Contract} contractVersion={contractVersion} />
      </DialogContent>

      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ContractCertificatesDialog

